import React, { useEffect } from 'react';
import styled from 'styled-components';
import ContentLoader from 'react-content-loader';
import { useApi } from '../hooks/useApi';

const DivContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  min-height: 400px;

  p {
    text-align: center;
    // width: 80%;
    padding: 2rem 5rem;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;

export const PageOrdenes = () => {
  window.scroll(0, 0)
  const { laboratorios, getLaboratorios } = useApi();
  const bodyHTML =
    laboratorios.data.length > 0 && laboratorios.data[0].texto_completo;

  useEffect(() => {
    getLaboratorios();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DivContainer id='contBodyHTML'>
      {laboratorios.isLoading ? (
        <div>
          <ContentLoader
            speed={2}
            width='80%'
            height={450}
            backgroundColor='#05AAAA'
          />
        </div>
      ) : (
        <p dangerouslySetInnerHTML={{ __html: bodyHTML }} />
      )}
    </DivContainer>
  );
};
